export const iconFontAwesomeTextformattingFilterCircleXmark = (
	<i className="fa-solid fa-filter-circle-xmark"></i>
);
